/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AdminAddressDTO,
  AdminAddressWithLegalFormDTO,
  CompanyDisplayDTO,
  ErrorResponse,
  LogDTO,
  MailDTO,
  ServerInfoDTO,
  TimeControlDTO,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class AdminApi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags admin-api
   * @name Anonymize
   * @request POST:/api/admin/anonymize
   * @secure
   */
  anonymize = (
    query: {
      /** @format int64 */
      id: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<CompanyDisplayDTO, ErrorResponse>({
      path: `/api/admin/anonymize`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags admin-api
   * @name ExecuteCompanyWatch
   * @request POST:/api/admin/execute-company-watch
   * @secure
   */
  executeCompanyWatch = (params: RequestParams = {}) =>
    this.request<void, ErrorResponse>({
      path: `/api/admin/execute-company-watch`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags admin-api
   * @name ExecuteDistanceCalculation
   * @request POST:/api/admin/execute-distance-calculation
   * @secure
   */
  executeDistanceCalculation = (params: RequestParams = {}) =>
    this.request<void, ErrorResponse>({
      path: `/api/admin/execute-distance-calculation`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags admin-api
   * @name ExecuteDocumentRetention
   * @request POST:/api/admin/execute-document-retention
   * @secure
   */
  executeDocumentRetention = (params: RequestParams = {}) =>
    this.request<void, ErrorResponse>({
      path: `/api/admin/execute-document-retention`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags admin-api
   * @name ExecuteGeocoding
   * @request POST:/api/admin/execute-geocoding
   * @secure
   */
  executeGeocoding = (params: RequestParams = {}) =>
    this.request<void, ErrorResponse>({
      path: `/api/admin/execute-geocoding`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags admin-api
   * @name ExecuteMailSender
   * @request POST:/api/admin/execute-mail-sender
   * @secure
   */
  executeMailSender = (params: RequestParams = {}) =>
    this.request<void, ErrorResponse>({
      path: `/api/admin/execute-mail-sender`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags admin-api
   * @name ExecuteOrderWatch
   * @request POST:/api/admin/execute-order-watch
   * @secure
   */
  executeOrderWatch = (params: RequestParams = {}) =>
    this.request<void, ErrorResponse>({
      path: `/api/admin/execute-order-watch`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags admin-api
   * @name ExecuteRequestWatch
   * @request POST:/api/admin/execute-request-watch
   * @secure
   */
  executeRequestWatch = (params: RequestParams = {}) =>
    this.request<void, ErrorResponse>({
      path: `/api/admin/execute-request-watch`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * @description Returns all addresses with company and request context
   *
   * @tags admin-api
   * @name GetAllAddresses
   * @summary Get all addresses
   * @request GET:/api/admin/addresses
   * @secure
   */
  getAllAddresses = (params: RequestParams = {}) =>
    this.request<AdminAddressDTO[], ErrorResponse>({
      path: `/api/admin/addresses`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags admin-api
   * @name GetMails
   * @request GET:/api/admin/mails-all
   * @secure
   */
  getMails = (params: RequestParams = {}) =>
    this.request<MailDTO[], ErrorResponse>({
      path: `/api/admin/mails-all`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags admin-api
   * @name GetServerInfo
   * @request GET:/api/admin/server-info
   * @secure
   */
  getServerInfo = (params: RequestParams = {}) =>
    this.request<ServerInfoDTO, ErrorResponse>({
      path: `/api/admin/server-info`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags admin-api
   * @name GetTimeControl
   * @request GET:/api/admin/time-control
   * @secure
   */
  getTimeControl = (params: RequestParams = {}) =>
    this.request<TimeControlDTO, ErrorResponse>({
      path: `/api/admin/time-control`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Returns a paginated slice of a log file. offset=-1 returns the last 'limit' lines (tail). Hard cap: limit must be between 1 and 10000 (enforced via Bean Validation, returns 400 on violation).
   *
   * @tags admin-api
   * @name Log
   * @summary Get log file content
   * @request GET:/api/admin/log
   * @secure
   */
  log = (
    query?: {
      file?: string;
      /**
       * @format int32
       * @min 1
       * @max 10000
       * @default 500
       */
      limit?: number;
      /**
       * @format int64
       * @default -1
       */
      offset?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<LogDTO, ErrorResponse>({
      path: `/api/admin/log`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags admin-api
   * @name LogFiles
   * @request GET:/api/admin/log-files
   * @secure
   */
  logFiles = (params: RequestParams = {}) =>
    this.request<string[], ErrorResponse>({
      path: `/api/admin/log-files`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags admin-api
   * @name Logger
   * @summary Check the remote address and IP-related headers of the request
   * @request GET:/api/admin/check-remote-addr
   * @secure
   */
  logger = (params: RequestParams = {}) =>
    this.request<Record<string, string>, ErrorResponse>({
      path: `/api/admin/check-remote-addr`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags admin-api
   * @name SetTimeControl
   * @request POST:/api/admin/time-control
   * @secure
   */
  setTimeControl = (
    query?: {
      /** @format date */
      referenceDate?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<TimeControlDTO, ErrorResponse>({
      path: `/api/admin/time-control`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Updates address fields and coordinates
   *
   * @tags admin-api
   * @name UpdateAddress
   * @summary Update address
   * @request PUT:/api/admin/addresses/{id}
   * @secure
   */
  updateAddress = (
    id: number,
    data: AdminAddressDTO,
    params: RequestParams = {},
  ) =>
    this.request<AdminAddressDTO, ErrorResponse | AdminAddressDTO>({
      path: `/api/admin/addresses/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Atomically updates a company address (including a country change) together with a new legal form for the address's company
   *
   * @tags admin-api
   * @name UpdateAdminAddressWithLegalForm
   * @summary Update address with legal form
   * @request PUT:/api/admin/addresses/{id}/with-legal-form
   * @secure
   */
  updateAdminAddressWithLegalForm = (
    id: number,
    data: AdminAddressWithLegalFormDTO,
    params: RequestParams = {},
  ) =>
    this.request<AdminAddressDTO, ErrorResponse | AdminAddressDTO>({
      path: `/api/admin/addresses/${id}/with-legal-form`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
